import { FormProvider, useForm } from 'react-hook-form';
import styled from 'styled-components';

import FlexWrap from '@/components/common/FlexWrap';
import TableHeader from '@/components/refund/PaymentComplete/TableHeader';

import LoadingView from '@/components/common/LoadingView';
import SearchBar from './SearchBar';
import { GLOBAL_PAYMENT_HEADER } from '@/constants/globalPayment.const';
import GlobalPaymentDateSelector from './GlobalPaymentDateSelector';
import { useGetPaymentHistory } from '@/hooks/useGetPaymentHistory';
import GlobalPaymentItem from './GlobalPaymentItem';
import GlobalPaymentViewSelector from './GlobalPaymentViewSelector';
import PagingWithLastPage from '../common/PagingWithLastPage';
import GlobalPaymentCreateButton from './GlobalPaymentCreateButton';

function GlobalPaymentList() {
  const {
    data,
    totalPage,
    refetch,
    pageNumber,
    setPageNumber,
    setSize,
    isLoading,
    setKeyword,
  } = useGetPaymentHistory();
  const methods = useForm({
    defaultValues: {
      checked: false,
    },
  });

  return (
    <FormProvider {...methods}>
      <Header>
        <SubTitle>해외 간편 결제</SubTitle>
        <FlexWrap gap='10px' alignItems='center'>
          <GlobalPaymentCreateButton />
        </FlexWrap>
      </Header>
      <SortingWrapper>
        <GlobalPaymentDateSelector
          isRefundDetail
          setPageNumber={setPageNumber}
        />

        <SearchBar setKeyword={setKeyword} />
        <GlobalPaymentViewSelector
          setPageNumber={setPageNumber}
          setSize={setSize}
        />
      </SortingWrapper>
      {isLoading ? (
        <LoadingView height='80vh' />
      ) : (
        <>
          <TableHeader titleList={GLOBAL_PAYMENT_HEADER} />
          {data && data.content.length > 0 ? (
            <List>
              {data.content.map((qrOrder, index) => (
                <GlobalPaymentItem
                  key={qrOrder.qrOrderId}
                  qrOrder={qrOrder}
                  index={index}
                  currentPage={data.number}
                  refetch={refetch}
                />
              ))}
            </List>
          ) : (
            <PaymentNotContainer>결제 내역이 없습니다</PaymentNotContainer>
          )}
        </>
      )}

      <PagingWithLastPage
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        totalPage={totalPage}
      />
    </FormProvider>
  );
}

export default GlobalPaymentList;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 28px;
`;

const SubTitle = styled.h3`
  font-size: ${(props) => props.theme.fontSize.regular};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  line-height: ${(props) => props.theme.lineHeight.regular};
  color: ${(props) => props.theme.mono[80]};
`;

const List = styled.ul`
  margin-bottom: 30px;
`;

const PaymentNotContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 708px;
  flex: 1;
  background-color: #fff;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  color: var(--Mono-50, #80848a);
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;

const BtnIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const SortingWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  gap: 12px;
`;
